import React from 'react';
import { Paper, Box } from '@mui/material';
import { Header } from './container/Header';
import { JFormik } from '../forms';
import * as Yup from 'yup';
import moment from 'moment';
import { Loading } from '../Loading';

export interface EmailViewFormProps {
  date?: Date;
  form: JSX.Element;
  caption?: any;
  loading?: boolean;
}

export const EmailViewForm = ({
  date,
  form,
  caption,
  loading,
}: EmailViewFormProps) => {
  return (
    <Paper elevation={5} sx={{ width: 900, maxWidth: '95%', margin: 'auto' }}>
      <Header date={date} caption={caption} />
      <Box sx={{ py: 2, px: 2 }}>{loading ? <Loading /> : form}</Box>
    </Paper>
  );
};
